import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './CategoryDetail.css'; 
import { FaChevronLeft } from 'react-icons/fa';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const CategoryDetail = () => {
  const { slug } = useParams(); 
  const [products, setProducts] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Kanka, eğer kategoride hiç ürün yoksa görünecek varsayılan görsel
  const defaultHeroImg = "https://images.unsplash.com/photo-1596567111059-598920404771?q=80&w=2070&auto=format&fit=crop";

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    // 1. Kategori bilgilerini çek
    const qCat = query(collection(db, "categories"), where("slug", "==", slug));
    const unsubCat = onSnapshot(qCat, (snap) => {
      if (!snap.empty) {
        setCategoryInfo(snap.docs[0].data());
      }
    });

    // 2. Bu kategoriye ait ürünleri çek (En yeni en üstte olacak şekilde)
    const qProd = query(
      collection(db, "products"), 
      where("cat", "==", slug),
      orderBy("createdAt", "desc")
    );
    
    const unsubProd = onSnapshot(qProd, (snap) => {
      const prodData = snap.docs.map(doc => ({
        docId: doc.id,
        ...doc.data()
      }));
      setProducts(prodData);
      setLoading(false);
    });

    return () => {
      unsubCat();
      unsubProd();
    };
  }, [slug]);

  // KAPAK RESMİ MANTIĞI:
  // Eğer ürün varsa ilk ürünün resmini al, yoksa kategorinin kendi resmini dene, o da yoksa default koy.
  const heroBackground = products.length > 0 
    ? products[0].img 
    : (categoryInfo?.coverImg || defaultHeroImg);

  if (loading) return <div className="category-detail-page"><Navbar /><div className="loader">Koleksiyon Hazırlanıyor...</div></div>;

  return (
    <div className="category-detail-page">
      <Navbar />
      
      <div className="category-hero" style={{ 
        backgroundImage: `linear-gradient(rgba(18,16,14,0.75), rgba(18,16,14,0.9)), url(${heroBackground})` 
      }}>
        <div className="category-hero-content">
          <Link to="/kategoriler" className="back-link">
            <FaChevronLeft /> Kategorilere Dön
          </Link>
          <h1 className="category-main-title">
            {categoryInfo?.title || "Özel"} <em>Koleksiyonu</em>
          </h1>
          <div className="title-separator"></div>
          <p className="category-count">{products.length} Nadir Eser Listeleniyor</p>
        </div>
      </div>

      <div className="category-products-container">
        {products.length > 0 ? (
          <div className="products-grid">
            {products.map((product) => (
              <Link 
                to={`/urun/${product.id}`} 
                key={product.docId} 
                className={`product-card-premium ${product.size || 'small'}`}
              >
                <div className="card-image-wrapper">
                  <img src={product.img} alt={product.name} />
                  <div className="card-badge">#{product.id}</div>
                  <div className="card-overlay">
                    <span className="view-text">DETAYI GÖR</span>
                  </div>
                </div>
                <div className="card-info-premium">
                  <h3>{product.name}</h3>
                  <div className="card-footer">
                    <span className="price">{product.price}</span>
                    <div className="line"></div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="no-results">
            Bu kategoride henüz sergilenen bir eser bulunmuyor kanka.
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CategoryDetail;